import style from './ActivityReport.module.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Users from '../../components/UseList';
import Activity from '../../components/Activity';
import BookList from '../../components/BookList';
import Overview from '../../components/Overview';
// import Pagination from './Pagination';

const ActivityReport = () => {
  const [activity, setActivity] = useState([]);
  const [message, setMessage] = useState('');
  const [displayComponent, setDisplayComponent] = useState("activity");
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [booksPerLanguage, setBooksPerLanguage] = useState([]);
  const [totalBooksPlayed, setTotalBooksPlayed] = useState(0);
  const [totalPlayTime, setTotalPlayTime] = useState(0);
  const base_url = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    console.log(users);
    fetchActivity();
    fetchData();
    fetchBooksByLanguage(); 
    fetchTotalBooksPlayedThisMonth();
    fetchTotalPlayTimeForBooksThisMonth();
  }, []);

  const fetchActivity = async () => {
    try {
      const resp = await axios.get(`${base_url}/user/userActivity`);
      // console.log(resp.data);
      setActivity(resp.data.result);
    } catch (error) {
      console.log(`error in fetchActivity : ${error.message}`);
      setMessage('Failed to fetch user activity');
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${base_url}/user/userList`);
      console.log(response.data);
      setUsers(response.data.users);
    } catch (error) {
      console.error('Error fetching users:', error);
      setMessage('Failed to fetch user list');
    } finally {
      setLoading(false);
    }
  };
  const fetchBooksByLanguage = async () => {
    setLoading(true);
    try {
        const response = await axios.get(`${base_url}/ivr/booksByLanguage`);
        console.log(response.data);
        setBooksPerLanguage(response.data.booksPerLanguage);
    } catch (error) {
        console.error('Error fetching books by language:', error);
        setMessage('Failed to fetch books by language');
    } finally {
        setLoading(false);
    }
};
const fetchTotalBooksPlayedThisMonth = async () => {
  setLoading(true);
  try {
      const response = await axios.get(`${base_url}/ivr/totalBooksPlayedThisMonth`);
      console.log(response.data);
      setTotalBooksPlayed(response.data.totalBooksUpdatedThisMonth);
      // setTotalPlayTime(response.data.totalPlaybackTime);
  } catch (error) {
      console.error('Error fetching total books played this month:', error);
      setMessage('Failed to fetch total books played this month');
  } finally {
      setLoading(false);
  }
};
const fetchTotalPlayTimeForBooksThisMonth = async () => {
  setLoading(true);
  try {
      const response = await axios.get(`${base_url}/ivr/totalPlayTimeForBooksThisMonth`);
      console.log(response.data);
      setTotalPlayTime(response.data.totalPlayTimeThisMonth);
  } catch (error) {
      console.error('Error fetching total play time for books played this month:', error);
      setMessage('Failed to fetch total play time for books played this month');
  } finally {
      setLoading(false);
  }
};
  return (
    <div className={style.maindiv}>
      <button onClick={() => setDisplayComponent('overview')} className={`${style.toggleBtn} ${displayComponent === "overview" ? style.activeBtn : ''} text-black`}>Overview</button>
      <button onClick={() => setDisplayComponent('activity')} className={`${style.toggleBtn} ${displayComponent === "activity" ? style.activeBtn : ''} text-black`}>User Activity</button>
      <button onClick={() => setDisplayComponent('user')} className={`${style.toggleBtn} ${displayComponent === "user" ? style.activeBtn : ''} text-black`}>User List</button>
      <button onClick={() => setDisplayComponent("books")} className={`${style.toggleBtn} ${displayComponent === "books" ? style.activeBtn : ''} text-black`}>Books</button>

      {/* Display loader if data is loading */}
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          {displayComponent === "overview" && <Overview users={users} booksPerLanguage={booksPerLanguage} totalBooksPlayed={totalBooksPlayed} totalPlayTime={totalPlayTime} message={message} /> }
          {displayComponent === "activity" && <Activity activity={activity} message={message} />}
          {displayComponent === "user" && <Users users={users} message={message} />}
          {displayComponent === "books" && <BookList activity={activity} message={message} />}
        </>
      )}
    </div>
  );
};

export default ActivityReport;
